import React from 'react';
import { useSelector } from "react-redux";
import { AES } from 'crypto-js';
import { Link } from 'react-router-dom';
import moment from "moment-timezone";
import "./ClientOverviewListingRecenInvoices.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useFetchClientInvoices } from '../ClientInvoice/useClientInvoice';
import { dateCliInvConvert } from '../../../helpers/dateHelper';
import invStatusConsts from "../../../constants/invStatusConsts";
import cliInvStatusConsts from '../../../constants/cliInvStatusConsts';

export function detailCTA(rowData) {
  const encryptedId = AES.encrypt(rowData._id, 'encryptionKey').toString();
  const encryptedCliId = AES.encrypt(rowData.cli_inv_for._id, 'encryptionKey').toString();
  const invId = encodeURIComponent(encryptedId).replace(/\//g, '%2F');
  const encodedId = encodeURIComponent(encryptedCliId).replace(/\//g, '%2F');

  return (
    <Link to={`../invoices/view/${invId}/${encodedId}`} className="cta-link">
      Details
    </Link>
  );
}

const formatCurrency = (value) => {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
}

const RecentInvoices = (props) => {

  let token = null;
  const { user } = useSelector((state) => state.auth);
  if (user) {
    if (user && user.token) {
      token = user.token;
    }
  }

  const { data: clientInvoiceList = [], isLoading, refetch: refetchClientInvoiceList, isError } = useFetchClientInvoices(props.id, token);

  const renderStatus = (rowData) => {
    // Determine the class based on the payment_status value
    let statusClass;
    let statusName;
    if (rowData.cli_inv_status === cliInvStatusConsts.Invoice_Send) {
      const startDate = moment().tz(global.config.getTimeZone());
      const endDate = moment(rowData.cli_inv_due_date).tz(global.config.getTimeZone());
      const diffInDays = endDate.diff(startDate, "days");
      if (diffInDays < 0) {
        statusClass = "overdue";
        statusName = "Overdue";
      } else {
        statusClass = "pending";
        statusName = "Invoice Sent";
      }
    } else if (rowData.cli_inv_status === cliInvStatusConsts.Pending) {
      // statusClass = "pending";
      // statusName = "Pending";
      const startDate = moment().tz(global.config.getTimeZone());
      const endDate = moment(rowData.cli_inv_due_date).tz(global.config.getTimeZone());
      const diffInDays = endDate.diff(startDate, "days");
      if (diffInDays < 0) {
        statusClass = "overdue";
        statusName = "Overdue";
      } else {
        statusClass = "pending";
        statusName = "Pending";
      }
    } else if (rowData.cli_inv_status === cliInvStatusConsts.Rejected) {
      statusClass = "overdue";
      statusName = "Cancelled";
    } else if (rowData.cli_inv_status === cliInvStatusConsts.Cancelled) {
      statusClass = "overdue";
      statusName = "Cancelled";
    } else if (rowData.cli_inv_status === cliInvStatusConsts.Payment_Processed) {
      statusClass = "manual";
      statusName = "Payment Processed";
    }
    return (
      <span className={`payment-status ${statusClass}`}>{statusName}</span>
    );
  };

  const renderAmount = (rowData) => {
    var totalAmount = rowData.cli_inv_total_amount.toLocaleString("en-US", {
      style: "currency",
      currency: rowData.cli_inv_currency,
    });

    return <span> {totalAmount}</span>;
  };

  return (
    <div className="listing-recent-invoice-inner">
      <style>
        {`
          @keyframes pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.5; }
          }
        `}
      </style>
      <div className="table-head-outer">
        <div className="table-head">
          Recent Invoices
        </div>
        <div className="view-button">
          <Link to={`/client/invoices/${encodeURIComponent(AES.encrypt(props.id, 'encryptionKey').toString().replace(/\//g, '%2F'))}`} className={window.location.pathname.startsWith('/client/invoices') ? 'active' : ''}>
            View All
          </Link>
        </div>
      </div>
      {isLoading ? (
        <DataTable
          value={Array.from({ length: 5 })}
          removableSort
          tableStyle={{ minWidth: "50rem", width: "100%", textAlign: "left" }}
          paginator={false}
          paginatorClassName="recent-invoices-pagination"
          rows={5}
        >
          <Column
            header="Invoice ID"
            sortable
            style={{ width: "25.8%" }}
            body={() => (
              <div
                style={{
                  width: "160px",
                  height: "22px",
                  borderRadius: "4px",
                  backgroundColor: "#e5e7eb",
                  animation: "pulse 1.5s ease-in-out infinite",
                }}
              />
            )}
          />
          <Column
            header="Due Date"
            sortable
            style={{ width: "26.4%" }}
            body={() => (
              <div
                style={{
                  width: "140px",
                  height: "22px",
                  borderRadius: "4px",
                  backgroundColor: "#e5e7eb",
                  animation: "pulse 1.5s ease-in-out infinite",
                }}
              />
            )}
          />
          <Column
            header="Status"
            sortable
            style={{ width: "27.8%" }}
            body={() => (
              <div
                style={{
                  width: "110px",
                  height: "30px",
                  borderRadius: "100px",
                  backgroundColor: "#e5e7eb",
                  animation: "pulse 1.5s ease-in-out infinite",
                }}
              />
            )}
          />
          <Column
            header="Amount"
            sortable
            style={{ width: "14.3%" }}
            body={() => (
              <div
                style={{
                  width: "120px",
                  height: "22px",
                  borderRadius: "4px",
                  backgroundColor: "#e5e7eb",
                  animation: "pulse 1.5s ease-in-out infinite",
                }}
              />
            )}
          />
          <Column
            field="_id"
            style={{ paddingRight: "20px" }}
            body={() => (
              <div
                style={{
                  width: "86px",
                  height: "30px",
                  borderRadius: "8px",
                  backgroundColor: "#e5e7eb",
                  animation: "pulse 1.5s ease-in-out infinite",
                }}
              />
            )}
          />
        </DataTable>
      ) : (
        <DataTable
          value={clientInvoiceList.slice(0, 5)}
          removableSort
          tableStyle={{ minWidth: "50rem", width: "100%", textAlign: "left" }}
          paginator={false}
          paginatorClassName="recent-invoices-pagination"
          rows={5}
          emptyMessage="No invoices found under this client"
        >
          <Column
            field="cli_inv_number"
            header="Invoice ID"
            sortable
            style={{ width: "25.8%" }}
          ></Column>
          <Column
            field="cli_inv_due_date"
            body={dateCliInvConvert}
            header="Due Date"
            sortable
            style={{ width: "26.4%" }}
          ></Column>
          <Column
            field="cli_inv_status"
            header="Status"
            body={renderStatus}
            sortable
            style={{ width: "27.8%" }}
          ></Column>
          <Column
            field="cli_inv_total_amount"
            header="Amount"
            body={renderAmount}
            sortable
            style={{ width: "14.3%" }}
          ></Column>
          <Column
            field="_id"
            body={detailCTA}
            style={{ paddingRight: "20px"}}
          ></Column>
        </DataTable>
      )}
    </div>
  );

};
export default RecentInvoices;